import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import FancyPopup from '../FancyPopup/FancyPopup';
import styles from './FancyTooltip.module.less';
function FancyTooltip(props) {
    const { action = 'hover', children, content, ...rest } = props;
    return _jsx(FancyPopup, { action: action, trigger: children, body: content, className: styles.content, ...rest });
}
export default memo(FancyTooltip);
